import { render } from "./canva_cta_pre.vue?vue&type=template&id=1bdbe18c&scoped=true"
import script from "./canva_cta_pre.vue?vue&type=script&lang=js"
export * from "./canva_cta_pre.vue?vue&type=script&lang=js"

import "./canva_cta_pre.vue?vue&type=style&index=0&id=1bdbe18c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bdbe18c"]])

export default __exports__